const gifFrames = require('gif-frames');
const getGifFrames = (url: string) => {
    return new Promise((success, error) => {
        gifFrames(
            { url: url, quality: '100', frames: 'all', outputType: 'canvas', cumulative: true },
            (err: any, frameData: any) => {
                if (err) {
                    error(err);
                } else {
                    success(
                        frameData.map((frame: any) =>
                            (frame.getImage() as HTMLCanvasElement).toDataURL()
                        )
                    );
                }
            }
        );
    });
};

export default getGifFrames;
